'use client';

const enabledFeatues = process.env.NEXT_PUBLIC_ENABLED_FEATURES?.split(',') || [];

export default function FeatureFlag({ featureName, children }) {
  // console.log('features:',process.env.NEXT_PUBLIC_ENABLED_FEATURES);
  const isEnabled = enabledFeatues.includes(featureName);
  if (isEnabled) return children;
  return null;
}
